import script from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=0032ac6e&scoped=true&lang=css"

import exportComponent from "../../../../../apps/evankao/game-yiyouwang/yywfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0032ac6e"]])

export default __exports__